import { useEffect, useRef } from "react";
import { useMultiAgentStore } from "@/stores/multiAgentStore";

export function Narration() {
  const reasoningBuffer = useMultiAgentStore((s) => s.reasoningBuffer);
  const nodes = useMultiAgentStore((s) => s.nodes);
  const status = useMultiAgentStore((s) => s.status);
  const bodyRef = useRef<HTMLDivElement>(null);

  const activeIds = Object.values(nodes)
    .filter((n) => n.status === "running" || n.status === "tool_calling")
    .map((n) => n.id);
  const sourceIds = activeIds.length > 0 ? activeIds : Object.keys(reasoningBuffer);
  if (!sourceIds.includes("planner")) sourceIds.push("planner");

  const text = sourceIds
    .map((id) => reasoningBuffer[id] || "")
    .filter(Boolean)
    .join("\n\n")
    .trim();

  const statusLine = text
    ? ""
    : Object.values(nodes)
        .filter((n) => n.status === "running" || n.status === "tool_calling")
        .map((n) => (n.toolInFlight ? `${n.task} · ${n.toolInFlight}` : n.task))
        .filter(Boolean)
        .join("   ·   ");
  const shown = text || statusLine;

  useEffect(() => {
    const el = bodyRef.current;
    if (!el) return;
    const distanceFromBottom = el.scrollHeight - el.scrollTop - el.clientHeight;
    if (distanceFromBottom > 80) return;
    const frame = requestAnimationFrame(() => {
      if (bodyRef.current) bodyRef.current.scrollTop = bodyRef.current.scrollHeight;
    });
    return () => cancelAnimationFrame(frame);
  }, [shown]);

  if (!shown) return null;

  const phase =
    status === "planning" ? "Planning" :
    status === "starting" ? "Starting" :
    "Thinking";

  return (
    <div style={{ paddingLeft: "clamp(24px, 3vw, 48px)", paddingRight: "clamp(24px, 3vw, 48px)", paddingBottom: 16 }}>
      <div
        className="ma-fade-up"
        style={{
          background: "var(--ma-surface-soft)",
          borderLeft: "2px solid hsl(var(--primary) / 0.85)",
          borderRadius: "0 var(--ma-radius-sm) var(--ma-radius-sm) 0",
          padding: "12px 16px",
        }}
      >
        <div className="ma-micro mb-2 flex items-center gap-2" style={{ color: "var(--ma-text-muted)" }}>
          <span className="ma-dot ma-dot--busy" style={{ width: 6, height: 6 }} />
          {phase}
        </div>
        <div style={{ position: "relative" }}>
          <div
            ref={bodyRef}
            style={{
              fontSize: 13,
              fontStyle: "italic",
              color: "var(--ma-text-muted)",
              lineHeight: 1.6,
              maxHeight: 180,
              overflowY: "auto",
              whiteSpace: "pre-wrap",
            }}
          >
            {shown}
          </div>
          <div
            aria-hidden
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              height: 28,
              background: "linear-gradient(to bottom, transparent, var(--ma-surface-soft))",
              pointerEvents: "none",
            }}
          />
        </div>
      </div>
    </div>
  );
}
